import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { changePasswordPost } from "../repositories/userRepo";



const initialState = {
  response: {},
  loading: false,
  error: false,
  errorMsg: "",
};
export const changePasswordData= createAsyncThunk(
  "changePassword",
  async (data, thunkAPI) => {
    const response = await changePasswordPost(data);
    return response;
  }
);
export const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  extraReducers: {
    [changePasswordData.pending]: (state) => {
      state.loading = true;
    },
    [changePasswordData.fulfilled]: (state, action) => {
      state.loading = false;

      state.response = action.payload;
      console.log(action.payload);
    },
    [changePasswordData.rejected]: (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = action.error.message;
      console.log(action.error);
    },
  },
  reducers: {},
});

export default changePasswordSlice.reducer;
